import React from 'react'
import {Navigate, useLocation} from "react-router-dom"
import Cookies from 'js-cookie';

const ProtectedRoute = ({children}) => {
    let location = useLocation();

    if(!Cookies.get('apiKey') && !Cookies.get('sessionKey')) {
        // If there is no API key or sessionKey, redirect to the API key page
        return <Navigate to="/enterapikey" state={{ from: location}} replace />
    }
 return children

};

export default ProtectedRoute;
